import {
  Box,
  Breakpoint,
  Color,
  FontWeight,
  GridDisplay,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import type { DashboardExperienceRafCampaignResponse } from '@library/api-dashboard-experience'
import React from 'react'

type RafCampaignTiersProps = {
  tiers: DashboardExperienceRafCampaignResponse['tiers']
}

const TierCard = withCitrusTheme(Box, (theme) => ({
  alignItems: 'center',
  border: `1px dashed ${theme.color(Color.Secondary_300)}`,
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '72px',
  padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
  textAlign: 'center',
  [`@media (min-width: ${Breakpoint.Medium})`]: {
    minHeight: '80px',
  },
}))

export function RafCampaignTiers({ tiers }: RafCampaignTiersProps) {
  return (
    <Box
      display={GridDisplay.Grid}
      gap={3}
      gridTemplateColumns="repeat(3, minmax(0, 1fr))"
      width="100%"
    >
      {tiers.map((tier) => (
        <TierCard key={`${tier.name}-${tier.amount}`}>
          <Text color={Color.ColdGrey_100} fontWeight={FontWeight.Bold} size={[5, 7]}>
            {tier.amount}
          </Text>
          <Text color={Color.ColdGrey_600} fontWeight={FontWeight.Bold} size={[2, 3]}>
            {tier.name}
          </Text>
        </TierCard>
      ))}
    </Box>
  )
}
